import React from 'react';
export function Header() {
  return <header className="bg-white/90 backdrop-blur-md py-4 px-5 md:px-8 sticky top-0 z-50 shadow-sm border-b border-brand-sage/30" data-id="element-121">
      <div className="max-w-5xl mx-auto flex justify-between items-center gap-4" data-id="element-122">
        <div className="font-serif font-bold text-xl md:text-2xl text-brand-dark tracking-wide whitespace-nowrap" data-id="element-123">
          Desincha40+
        </div>
        <a href="#oferta" className="bg-brand-dark hover:bg-brand-text text-white font-medium px-5 py-2.5 rounded-full transition-all duration-300 shadow-md text-sm md:text-base whitespace-nowrap" data-id="element-124">
          QUERO O PROTOCOLO
        </a>
      </div>
    </header>;
}